module.exports = __webpack_public_path__ + "static/media/mmc.7e09e4ea.png";